<script setup lang="ts">
    import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from "radix-vue";
    import { Input } from "@/vue/ui/input";
    import { RangeInputState, useFilterPrice } from "@/vue/composables/useFilterPrice";

    const props = defineProps<{
        state: RangeInputState,
    }>();

    const {
        range,
        sliderValue,
        inputValue,
        onSliderChange,
        onInputChange,
    } = useFilterPrice(props);
</script>

<template>
    <div class="md:px-4 md:py-6 md:w-[300px]">
        <div class="mb-4 grid grid-cols-2 gap-x-4">
            <div class="relative">
                <Input type="number" class="pr-6" v-model.number="inputValue[0]" @update:model-value="onInputChange" @blur="onSliderChange" />
                <div class="absolute right-4 text-body-sm text-neutral-900 top-1/2 -translate-y-1/2">€</div>
            </div>
            <div class="relative">
                <Input type="number" class="pr-6" v-model.number="inputValue[1]"  @update:model-value="onInputChange" @blur="onSliderChange" />
                <div class="absolute right-4 text-body-sm text-neutral-900 top-1/2 -translate-y-1/2">€</div>
            </div>
        </div>
        <SliderRoot
            class="relative flex w-full touch-none h-4 select-none items-center"
            v-model="sliderValue"
            :min="range.min"
            :max="range.max"
            @update:model-value="onSliderChange"
        >
            <SliderTrack class="relative h-[.3215rem] w-full grow overflow-hidden rounded-full bg-neutral-100">
                <SliderRange class="absolute h-full bg-primary" />
            </SliderTrack>
            <SliderThumb
                v-for="i in 2"
                class="block h-4 w-4 rounded-full border-2 border-primary bg-primary ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
            />
        </SliderRoot>
    </div>
</template>
